<div class="confirmation-container" *ngIf="info.refId">
    <div class="m-4 d-flex justify-content-start align-items-center position-absolute start-0 back-button" (click)="handleBack()">
        <mat-icon class="d-flex align-items-center icon" fontIcon="arrow_back"></mat-icon>
        <span class="back-button-text">Back</span>
    </div>

    <div class="confirmation-container-header d-flex flex-column align-items-center justify-content-center">
        <div class="confirmation-container-header-icon rounded">
            <mat-icon [svgIcon]="screen"></mat-icon>
        </div>
        <div class="confirmation-container-header-title mt-1 text-white">Customer {{ screen }} request</div>
    </div>
    <div class="confirmation-container-basic-info rounded mx-2 p-2 mx-4">
        <div class="confirmation-container-basic-info-title">{{ screen === 'cash-in' ? 'Receiver Details' : 'Requesting account' }}</div>
        <div class="d-flex flex-column justify-content-center align-items-center">
            <!-- <img [src]="info.imgUrl" alt="" class="rounded-circle" style="width: 80px; height: 80px" /> -->
            <div class="font-weight-bold fs-5">{{ info.name }}</div>
            <div class="wallet-info">{{ info.currency }} Wallet : {{ info.walletId }}</div>
            <hr style="width: -webkit-fill-available" />
            <div class="client-info d-flex justify-content-between align-items-center">
                <div class="email pe-3 border-end text-truncate" [title]="info.email">{{ info.email }}</div>
                <div class="mobile px-3 border-end text-truncate" [title]="info.mobile">{{ info.mobile }}</div>
                <div class="validity ps-3 d-flex flex-column justify-content-center align-items-center" [class.error-message]="this.countdown === 'exipred'">
                    Req {{ this.countdown !== 'exipred' ? 'valid for' : 'expired' }}
                    <span class="fw-semibold timer" *ngIf="this.countdown !== 'exipred'">
                        {{ countdown }}
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="confirmation-container-transaction-info rounded mx-2 p-2 mx-4 d-flex flex-column">
        <div class="d-flex justify-content-between py-1 px-2">
            <div class="amount">Amount</div>
            <div class="transaction-type d-flex justify-content-end align-items-center rounded-pill px-2">
                <mat-icon [svgIcon]="screen" style="color: #ff5400"></mat-icon> {{ screen }}
            </div>
        </div>

        <div class="d-flex justify-content-between py-1 px-2">
            <div class="total">
                {{ info.total }} <span style="font-size: 16px">{{ info.currency }}</span>
            </div>
            <div class="ref d-flex align-items-center py-2">Ref: {{ info.refId }} | {{ info.date | date : 'dd/M/YYYY' }}</div>
        </div>
    </div>

    <div class="confirmation-container-summary-info d-flex flex-column mx-4">
        <div class="summary-title px-2 mb-2">summary</div>
        <div class="container rounded d-flex flex-column justify-content-center">
            <div class="amount d-flex justify-content-between py-1 px-2">
                <div>{{ screen + ' Amount' }}</div>
                <div>{{ info.cashAmount }} {{ info.currency }}</div>
            </div>
            <div class="fee d-flex justify-content-between py-1 px-2">
                <div>Fee</div>
                <div>{{ info.fee }} {{ info.currency }}</div>
            </div>
            <div class="total d-flex justify-content-between py-1 px-2">
                <div>Total</div>
                <div>{{ info.total }} {{ info.currency }}</div>
            </div>
        </div>
    </div>

    <div class="confirmation-container-footer mb-2 px-4">
        <hr />
        <button
            (click)="onConfirm()"
            mat-raised-button
            class="btn-primary rounded-pill mx-2"
            [class.button-spinner]="loading"
            [disabled]="loading || this.countdown === 'exipred'"
            [class.btn-primary-disabled]="this.countdown === 'exipred'"
        >
            {{ loading ? '' : screen === 'cash-in' ? 'Confirm cash-in' : 'Confirm cash-out' }}
        </button>
        <button (click)="dialogRef.close()" mat-raised-button class="btn-secondary rounded-pill mx-2">Cancel</button>
    </div>
</div>

<app-spinner [isLoading]="info.refId ? false : true" />
